module.exports = __webpack_public_path__ + "img/modulo_Lead.5d6706f.svg";